import { API } from "./api";

export const getAllRestaurants = () => API.get(`/restaurants`);
export const getRestaurantsWithScreens = (startDate, numberOfWeeks, location) =>
  API.post(`/restaurants/getRestaurantsWithScreens`, {
    startDate,
    numberOfWeeks,
    location,
  });
export const getAllRestaurantsWithScreens = (startDate, numberOfWeeks) =>
  API.post(`/restaurants/getAllRestaurantsWithScreens`, {
    startDate,
    numberOfWeeks,
  });

export const getRestaurantById = (id) => API.get(`/restaurants/${id}`);

export const getFilteredRestaurants = (query) =>
  API.get(`/restaurants`, { params: query });
export const addRestaurant = (restaurant) =>
  API.post(`/restaurants`, restaurant);

export const updateRestaurant = (id, restaurant) =>
  API.put(`/restaurants/${id}`, restaurant);
export const deleteRestaurant = (id) => API.delete(`/restaurants/${id}`);
export const getRestaurantsByOwner = async (ownerId) => {
  return API.get(`/restaurants/owner/${ownerId}`);
};
